import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { SALENG_GREEN_API_PROD, SALENG_SHOP_API_PROD } from "./../config";

const SALENG_GREEN_API = SALENG_GREEN_API_PROD;
const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

function getAuthData() {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) throw new Error("No access token found");

  const decoded = jwtDecode(accessToken);
  return {
    token: accessToken,
    shopId: decoded?.id || null,
    branchId: decoded?.branchId || null,
  };
}

// Auth
export const loginGreen = (payload) => {
  return axios.post(`${SALENG_GREEN_API}/auth/login`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Categories
export const getCategories = () => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/categories/${shopId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createCategory = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(`${SALENG_SHOP_API}/categories/${shopId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const editCategory = (payload, id) => {
  const { shopId } = getAuthData();

  return axios.put(`${SALENG_SHOP_API}/categories/${shopId}/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const editCategory2 = (payload) => {
  return axios.put(`${SALENG_SHOP_API}/categories`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

// Sub-Categories
export const createSubCategory = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(`${SALENG_SHOP_API}/sub-categories/${shopId}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const editSubCategory = (payload, id) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${SALENG_SHOP_API}/sub-categories/${shopId}/${id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// Projuct

export const getProducts = () => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/products/${shopId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createProduct = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(`${SALENG_SHOP_API}/products/${shopId}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const deleteProduct = (id) => {
  const { shopId } = getAuthData();

  return axios.delete(`${SALENG_SHOP_API}/products/${shopId}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const updateProduct = (payload, id) => {
  const { shopId } = getAuthData();

  return axios.put(`${SALENG_SHOP_API}/products/${shopId}/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Adjustments
export const getProductAdjustments = (branchId) => {
  return axios.get(`${SALENG_SHOP_API}/products/adjustments/${branchId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createProductAdjustments = (payload, branchId) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/products/adjustments/${branchId}`,
    { ...payload, shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateProductAdjustments = (payload, branchId) => {
  return axios.put(
    `${SALENG_SHOP_API}/products/adjustments/${branchId}/${payload.productId}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const deleteProductAdjustments = (branchId, id) => {
  return axios.delete(
    `${SALENG_SHOP_API}/products/adjustments/${branchId}/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

// Adjuestments - Groups
export const getProductGroupsAdjustments = (customerGroupId) => {
  return axios.get(
    `${SALENG_SHOP_API}/products/adjustments/groups/${customerGroupId}`,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const createProductGroupsAdjustments = (payload, customerGroupId) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/products/adjustments/groups/${customerGroupId}`,
    { ...payload, shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const updateProductGroupsAdjustments = (payload, customerGroupId) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${SALENG_SHOP_API}/products/adjustments/groups/${customerGroupId}/${payload.productId}`,
    { ...payload, shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

// Shop
export const getShop = () => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/shop/${shopId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createShop = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/shop`,
    { ...payload, shopId: shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

// Branchs
export const getBranch = (branchId) => {
  return axios.get(`${SALENG_SHOP_API}/branches/${branchId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createBranch = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/branches`,
    { ...payload, shopId: shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const deleteBranch = (id) => {
  const { shopId } = getAuthData();

  return axios.delete(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const updateBranch = (id, payload) => {
  const { shopId } = getAuthData();

  return axios.put(`${SALENG_SHOP_API}/branches/${shopId}/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Users
export const getUser = (id) => {
  return axios.get(`${SALENG_GREEN_API}/users/` + id, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createUser = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/users`,
    { ...payload, shopId: shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const deleteUser = (id) => {
  const { shopId } = getAuthData();

  return axios.delete(`${SALENG_SHOP_API}/users/${shopId}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const updateUser = (id, payload) => {
  const { shopId } = getAuthData();

  return axios.put(`${SALENG_SHOP_API}/users/${shopId}/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const resetPassword = (username, password) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${SALENG_SHOP_API}/users/reset_password/${shopId}`,
    { username, password },
    {
      headers: {
        "Content-Type": "application/json",
        // "Authorization": "Bearer " + token,
      },
    }
  );
};

// Transaction
export const getTransaction = (transactionId) => {
  return axios.get(`${SALENG_SHOP_API}/transaction/` + transactionId, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const getShopTransaction = () => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/transaction/shop/${shopId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const getBranchTransaction = (branchId) => {
  return axios.get(`${SALENG_SHOP_API}/transaction/branch/${branchId}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Customer
export const getCustomers = (customerGroupId) => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/customer`, {
    params: { shopId, customerGroupId },
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Customer - Groups
export const getGroups = () => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/customer/groups`, {
    params: { shopId },
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createGroup = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(
    `${SALENG_SHOP_API}/customer/groups`,
    { ...payload, shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const editGroup = (payload, id) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${SALENG_SHOP_API}/customer/groups/${id}`,
    { ...payload, shopId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const deleteGroup = (id) => {
  return axios.delete(`${SALENG_SHOP_API}/customer/groups/${id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

// Product - Setting
export const getProductSettings = (branchId) => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/products/settings/${shopId}`, {
    params: { branchId },
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const createProductSetting = (payload) => {
  const { shopId } = getAuthData();

  return axios.post(`${SALENG_SHOP_API}/products/settings/${shopId}`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const updateProductSetting = (payload, branchId) => {
  const { shopId } = getAuthData();

  return axios.put(
    `${SALENG_SHOP_API}/products/settings/${shopId}/${branchId}`,
    payload,
    {
      // params: { branchId },
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    }
  );
};

export const getTest = (branchId, visible) => {
  const { shopId } = getAuthData();

  return axios.get(`${SALENG_SHOP_API}/products/data`, {
    params: { shopId, branchId, visible },
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};

export const getRoles = () => {
  return axios.get(`${SALENG_SHOP_API}/roles`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
